import React from 'react';
import { convertFieldTypeToQueryType } from '../../utils';
import RecipientAutoComplete from '../RecipientAutoComplete';
import type { IContact } from '../types';

type IProps = {
  autoFocus?: boolean;
  label: string;
  helperText: string;
  placeholder: string;
  handleOnChange: (e: any) => void;
  error: boolean;
  value: string;
  dataSpec?: string;
  name?: string;
  disabled?: boolean;
  contacts: IContact[];
  handleContactSelect: (e: any, queryType: string) => void;
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const RecipientTextField = (props: IProps) => {
  const searchType = convertFieldTypeToQueryType(props.label);
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const filterContacts = (value: string) => {
    const normalizedValue = value.trim().toLowerCase();
    // @ts-expect-error -- This code was written prior to enforcing lint rules
    return (contact: IContact) => contact[searchType]?.toLowerCase().includes(normalizedValue);
  };

  // @ts-expect-error -- This code was written prior to enforcing lint rules
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const getOptionLabel = (option) => `${option[convertFieldTypeToQueryType(props.label)]}`;

  return (
    <RecipientAutoComplete
      autoFocus={props.autoFocus}
      label={props.label}
      helperText={props.helperText}
      placeholder={props.placeholder}
      handleOnChange={props.handleOnChange}
      error={props.error}
      value={props.value}
      dataSpec={props.dataSpec}
      name={props.name}
      disabled={props.disabled}
      contacts={props.contacts}
      handleContactSelect={props.handleContactSelect}
      filterMethod={filterContacts}
      getOptionLabel={getOptionLabel}
    />
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default RecipientTextField;
